import { useUserSelector } from '../services/UserSelectorContext';

export const useUserRole = () => {
  const { user } = useUserSelector();

  const isSuperAdmin = () => {
    return user?.groups?.includes('superadmin');
  };

  const isAdmin = () => {
    return user?.groups?.includes('admin');
  };

  return {
    user,
    groups: user?.groups,
    isSuperAdmin: isSuperAdmin(),
    isAdmin: isAdmin()
  };
};
